var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"items":_vm.statusAction,"headers":_vm.statusActionHeaders,"items-per-page":-1}})
}
var staticRenderFns = []

export { render, staticRenderFns }